var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("site-url"),
        state: _vm.getState(_vm.$v.site_url),
        feedbacks: _vm.feedbacks(_vm.$v.site_url),
      },
    },
    [
      _c("EmdInput", {
        attrs: { name: "site_url" },
        on: { input: () => _vm.$v.site_url.$touch() },
        model: {
          value: _vm.recipient.site_url,
          callback: function ($$v) {
            _vm.$set(_vm.recipient, "site_url", $$v)
          },
          expression: "recipient.site_url",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }